import { NavLink } from 'react-router-dom';
import { Gamepad2, Globe, Layers, Wrench } from 'lucide-react';
import { cn } from '@/lib/utils';

interface NavItem {
  to: string;
  label: string;
  icon: typeof Gamepad2;
}

const items: NavItem[] = [
  { to: '/games', label: 'Games', icon: Gamepad2 },
  { to: '/version-mappings', label: 'Version Mappings', icon: Layers },
  { to: '/maintenance', label: 'Maintenance', icon: Wrench },
  { to: '/environments', label: 'Environments', icon: Globe },
];

export function Sidebar(): JSX.Element {
  return (
    <aside className="hidden md:flex w-56 flex-col border-r bg-muted/40">
      <nav className="flex-1 space-y-1 p-3">
        {items.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
              )
            }
          >
            <Icon className="h-4 w-4" />
            {label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
